import { watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { $axios, $queryClient } from '@/boot/initApi'

export default ({ items }) => ({
  indexRoles: ({ enabled = true } = {}) => {
    const query = useQuery({
      queryKey: ['roles'],
      queryFn: async () => {
        try {
          const { data } = await $axios.get('api/roles', { withCredentials: false, withXSRFToken: false })
          return data
        } catch (err) {
          console.error(err)
          return []
        }
      },
      enabled,
      staleTime: Infinity
    }, $queryClient)

    watch(query.data, val => {
      if (val) items.value = val
    }, { immediate: true })

    return query
  },

  findRole: id => items.value.find(i => i.id === id) ?? null
})
